export default ({ COLORS }) => ({
  group: {
    height: '40px',
    padding: '12px 15px',
    fontSize: '14px',
    lineHeight: '14px',
    backgroundColor: '#f9f9f9',
    border: '1px solid #ececec',
    borderRadius: '4px',
    color: COLORS.TEXT.MID_GREY.NORMAL,
    position: 'relative',
    display: 'flex'
  },
  icon: {
    position: 'absolute',
    right: '10px',
    top: '12px',
    cursor: 'pointer'
  },
  mis: {
    background: '#c5c5c5',
    display: 'block',
    borderRadius: '4px',
    fontSize: '11px',
    lineHeight: '12px',
    color: '#fff',
    padding: '2px 7px',
    marginLeft: '6px'
  }
})
